import React from 'react';
import Modal from 'react-modal';

interface RefreshWarningModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    onRefresh: () => void;
    reminderMinutes: number;
}

const RefreshWarningModal: React.FC<RefreshWarningModalProps> = ({
    isOpen,
    onDismiss,
    onRefresh,
    reminderMinutes,
}) => {
    const formatTime = (minutes: number): string => `${minutes} minute${minutes !== 1 ? 's' : ''}`;

    return (
        <Modal
            className="refresh-warning-modal"
            isOpen={isOpen}
            onRequestClose={onDismiss}
            contentLabel="Page Refresh Reminder"
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
        >
            <div className="modal-body">
                <p className="refresh-warning-modal__description">
                    You have been viewing this page for more than {formatTime(reminderMinutes)}. To ensure you&apos;re working with the most up-to-date timesheets, we recommend refreshing the page.
                </p>
                <p className="refresh-warning-modal__note">
                    This reminder will appear every {formatTime(reminderMinutes)}.
                </p>
            </div>

            <div className="modal-bottom-bar">
                <button
                    type="button"
                    className="table-action-button"
                    onClick={onRefresh}
                >
                    Refresh Now
                </button>
                <button
                    type="button"
                    className="table-action-button table-action-button-secondary"
                    onClick={onDismiss}
                >
                    Continue Working
                </button>
            </div>
        </Modal>
    );
};

export default RefreshWarningModal;

